import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { history } from "src/services/history";
import { NotificationService } from "src/helpers/notifications";
import { errorResponsesTrns } from "src/translate/responses";
import { PATHNAMES } from "src/constants/routes";
import { IInquiry } from "src/@types/inquiries";

export const CURRENT_INQUIRY_SLICE_NAME = "currentInquiry";

interface Params {
  id: string;
}

export const getCurrentInquiryAsync = createAsyncThunk(
  `${CURRENT_INQUIRY_SLICE_NAME}/fetchCurrentInquiry`,
  async ({ id }: Params, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<IInquiry>(`/inquiries/${id}/`);

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      history.push(PATHNAMES.HOME, { replace: true });

      NotificationService.error(errorText || errorResponsesTrns.currentInquiry);

      return rejectWithValue(errorText);
    }
  }
);
